import React, { useEffect, useRef, useState } from "react";
import {
  deBaseAFechaLocal,
  manejadorDeRespuesta,
} from "../../../../utils/Tools.js";
import { reservasAPI } from "../../../../utils/funcionesAPI.js";
import { toast, ToastContainer } from "react-toastify";

const ModalCuentaCorriente = (props) => {
  const myRefname = useRef(null);
  const { reserva, onCancelarClick } = props;
  const { numeroReserva, estado } = reserva;
  const [cuentaCorriente, setCuentaCorriente] = useState([]);

  const tipoCliente = sessionStorage.getItem("tipoCliente");
  const token = sessionStorage.getItem("token");

  const traerCuentaCorrienteDeLaReserva = (numReserva) => {
    const datos = JSON.stringify({
      peticion: "traerCuentaCorrienteDeLaReserva",
      numeroReserva: numReserva,
      token,
      canal: "WEB",
    });
    reservasAPI(datos)
      .then((respuesta) => {
        if (manejadorDeRespuesta(props, respuesta)) {
          setCuentaCorriente(respuesta.data);
        }
      })
      .catch((e) => {
        toast.error("Ha ocurrido un error en buscar la cuenta corriente.", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      });
  };

  useEffect(() => {
    myRefname.current.click();
    traerCuentaCorrienteDeLaReserva(numeroReserva);
  }, []);

  return (
    <div id="loader" className="loader modalCuentaCorriente">
      <button
        ref={myRefname}
        type="button"
        style={{ display: "none" }}
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#exampleModalCenter"
      >
        Launch demo modal
      </button>

      <div
        className="modal fade"
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered  modal-95w" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Cuenta Corriente para la reserva N° {numeroReserva}
              </h5>
              <button
                type="button"
                onClick={() => onCancelarClick(false)}
                style={{ color: "#fff", opacity: "1", textShadow: "none" }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <table className="tablaPasajerosEnMisReservas">
                <thead>
                  <tr>
                    <th>Emisión</th>
                    <th>Nro. Formulario</th>
                    <th>Descripción Frm.</th>
                    <th>Moneda Pago</th>
                    <th>Cotiz. Pago</th>
                    <th>Importe Pago</th>
                    <th>Moneda PQ</th>
                    <th>Cotiz. PQ</th>
                    <th>Importe PQ</th>
                    <th>Debe</th>
                    <th>Haber</th>
                    <th>Tipo Valor</th>
                    <th>Titular</th>
                    <th>Nro. Cupón</th>
                    <th>Num. Tarjeta</th>
                    <th>Tarjeta</th>
                    <th>Tasa</th>
                    <th>Cuotas</th>
                    <th>Intereses</th>
                  </tr>
                </thead>
                <tbody>
                  {cuentaCorriente.length === 0 && (
                    <tr>
                      <td colSpan="5">No hay datos</td>
                    </tr>
                  )}
                  {cuentaCorriente.map((cuenta) => {
                    return <tr>
                      <td>{cuenta.emision}</td>
                      <td>{cuenta.nroFormulario}</td>
                      <td>{cuenta.den_frm}</td>
                      <td>{cuenta.cod_moneda_VA}</td>
                      <td>{cuenta.cot_moneda_VA}</td>
                      <td>{cuenta.importe_moneda_VA}</td>
                      <td>{cuenta.cod_moneda_PQ}</td>
                      <td>{cuenta.cot_moneda_PQ}</td>
                      <td>{cuenta.importe_moneda_PQ}</td>
                      <td>{cuenta.debe}</td>
                      <td>{cuenta.haber}</td>
                      <td>{cuenta.cod_tipovalor}</td>
                      <td>{cuenta.titular}</td>
                      <td>{cuenta.nro_cupon}</td>
                      <td>{cuenta.numtar}</td>
                      <td>{cuenta.BUFFC_col1}</td>
                      <td>{cuenta.tasa}</td>
                      <td>{cuenta.cuotas}</td>
                      <td>{cuenta.importe_EX_VA}</td>
                    </tr>;
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalCuentaCorriente;



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/ReservaFila/ModalCuentaCorriente.js